module.exports = __webpack_public_path__ + "static/media/cross.2835d1ae.svg";